import { AreaProgram } from './area.program.model';
import { Lecturer } from './lecturer.model'
import { DayProgram } from './day-program.model'
import { Expositor } from './expositor/expositor.model';

export class SearchModel{
    public Palestrantes: Lecturer[] = []; 
    public AtividadesDia: DayProgram[] =  [];
    public AtividadesArea: AreaProgram[] = [];
    public Expositores: Expositor[] = [];
}



// WEBPACK FOOTER //
// ./src/models/search.model.ts